import { useQuery } from "@tanstack/react-query";
import { getTextileBackNames } from "api/textile_deals/fetchTextileBackNames";

export const useTextileNamesBackQuery = (textileOrderId?: number) => {
  return useQuery({
    queryKey: ['textile_back_names', textileOrderId],
    queryFn: () => getTextileBackNames(textileOrderId!),
    enabled: !!textileOrderId
  });
};